const PASS = 'PASS';
const AUTHENTICATE_TYPE = 'TWO_ELEMENTS';
// 测试租户
const TENANT_TYPE = [{
  value: 'TEST',
  label: '是',
}, {
  value: 'GENERAL',
  label: '否',
}];
const TENANT_TYPE_ENUM = TENANT_TYPE.reduce((total, currentValue) => ({
  ...total,
  [currentValue.value]: currentValue.label,
}), {});
// 是否公司
const SUBJECT_TYPE = [{
  value: 'PERSONAL',
  label: '个人',
}, {
  value: 'ENTERPRISE',
  label: '企业',
}];
const SUBJECT_TYPE_ENUM = SUBJECT_TYPE.reduce((total, currentValue) => ({
  ...total,
  [currentValue.value]: currentValue.label,
}), {});
const STATUS = [{
  value: 'ENABLED',
  label: '启用',
}, {
  value: 'DISABLED',
  label: '禁用',
}];
// 删除
const DELETED = 'DELETED';
const STATUS_ENUM = STATUS.reduce((total, currentValue) => ({
  ...total,
  [currentValue.value]: currentValue.label,
}), {});
export {
  DELETED,
  PASS, AUTHENTICATE_TYPE,
  TENANT_TYPE,
  TENANT_TYPE_ENUM,
  STATUS, STATUS_ENUM,
  SUBJECT_TYPE,
  SUBJECT_TYPE_ENUM,
};

export const fields = [
  {
    name: 'tenantNameLike',
    label: '租户名称：',
    type: 'input',
    props: {
      placeholder: '请输入租户名称',
      clearable: true,
    },
  },
  {
    name: 'tenantId',
    label: '租户编码：',
    type: 'input',
    props: {
      placeholder: '请输入荔枝号',
      clearable: true,
    },
  },
  {
    name: 'belongEnterpriseAuthType',
    label: '认证状态',
    type: 'select',
    options: [
      { value: '', label: '全部' },
      { value: true, label: '已认证' },
      { value: false, label: '未认证' },
    ],
    props: {
      placeholder: '请选择所属签约公司认证状态',
      clearable: true,
    },
  },
  {
    name: 'freshCompany',
    label: '是否内部租户：',
    type: 'select',
    options: [
      { value: '', label: '全部' },
      { value: true, label: '是' },
      { value: false, label: '否' },
    ],
    props: {
      placeholder: '请选择是否内部租户',
      clearable: true,
    },
  },
  {
    name: 'status',
    label: '租户状态：',
    type: 'select',
    options: [
      { value: '', label: '全部' },
      { value: 'ENABLED', label: '启用' },
      { value: 'DISABLED', label: '禁用' },
      { value: 'DISCARD', label: '注销' },
    ],
    props: {
      placeholder: '请选择租户状态',
      clearable: true,
    },
  },
];

// 租户类型
export const TENANT_BELONG_TYPE = {
  enterprise: 'ENTERPRISE_TENANT',
  department: 'DEPARTMENT_TENANT',
};

export const TENANT_TYPE_MAP = {
  [TENANT_BELONG_TYPE.enterprise]: '企业',
  [TENANT_BELONG_TYPE.department]: '部门',
};

// 菜单树操作配置
export const TENANT_OPERATION_TYPE = {
  edit: 1,
  add: 2,
  off: 3, // 注销
  delete: 4,
};

// 步骤进度配置
export const TENANT_STEPS_CONFIG = {
  base: 0,
  power: 1,
  manage: 2,
};
